<!-- Maintenance Banner (Feature 2 — DC-S-132) -->
<div *ngIf="showMaintenanceBanner" class="maintenance-banner">
  <div class="maintenance-banner__content">
    <i data-feather="alert-triangle" class="maintenance-banner__icon"></i>
    <div class="maintenance-banner__text">
      <strong>Hệ thống đang bảo trì</strong>
      <span class="maintenance-banner__sep">—</span>
      <span>Một số camera có thể bị gián đoạn.</span>
      <span *ngIf="maintenanceWindows[0]?.reason" class="maintenance-banner__reason">
        Lý do: {{ maintenanceWindows[0].reason }}
      </span>
      <span *ngIf="maintenanceWindows[0]?.operator" class="maintenance-banner__operator">
        (by {{ maintenanceWindows[0].operator }})
      </span>
    </div>
    <span class="badge badge-light-warning ml-1">{{ maintenanceWindows.length }} window</span>
  </div>
  <button class="maintenance-banner__dismiss" (click)="dismissMaintenanceBanner()" title="Ẩn thông báo">
    <i data-feather="x" style="width: 14px; height: 14px"></i>
  </button>
</div>

<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" width="36" />
        </span>
        <h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex align-items-center justify-content-between w-100 px-2">
  <!-- ZONE 1: LEFT -->
  <div class="navbar-zone-left d-flex align-items-center">
    <!-- Menu Toggler (Mobile) -->
    <ul class="nav navbar-nav d-xl-none mr-1" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle p-0" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>

    <!-- Dynamic Header Info (from NavbarPortalService) -->
    <ng-container *ngIf="pageHeader$ | async as header">
      <div class="navbar-header-info d-flex align-items-center">
        <!-- Compact Card Icon style if useCardIcon is true -->
        <div
          *ngIf="header.useCardIcon && header.icon"
          class="nav-icon-card module-icon-card mr-50"
          [ngClass]="[
            'nav-icon-card-' + (header.iconColor || 'primary'),
            'module-icon-card-' + (header.iconColor || 'primary')
          ]"
        >
          <lucide-angular [name]="header.icon" [size]="18"></lucide-angular>
        </div>
        <!-- Standard Icon style if useCardIcon is false -->
        <lucide-angular
          *ngIf="!header.useCardIcon && header.icon"
          [name]="header.icon"
          class="mr-50"
          [ngClass]="'text-' + (header.iconColor || 'primary')"
          [size]="18"
        ></lucide-angular>

        <h5 class="mb-0 font-weight-bolder text-truncate navbar-page-title">{{ header.title }}</h5>

        <span
          *ngIf="header.badgeText !== undefined && header.badgeText !== null && header.badgeText !== ''"
          class="badge badge-pill ml-50 navbar-page-badge font-small-1"
          [ngClass]="'badge-' + (header.badgeColor || 'light-primary')"
        >
          {{ header.badgeText }}
        </span>
      </div>
    </ng-container>

    <!-- Custom Left Portal Template -->
    <ng-container *ngTemplateOutlet="leftPortal$ | async"></ng-container>
  </div>

  <!-- ZONE 2: CENTER (Dynamic Portal Outlet) -->
  <div class="navbar-zone-center d-flex align-items-center justify-content-center flex-grow-1 px-1">
    <ng-container *ngTemplateOutlet="centerPortal$ | async"></ng-container>
    <app-stats-info *ngIf="hasRightPortal$ | async" [isCenter]="true"></app-stats-info>
  </div>

  <!-- ZONE 3: RIGHT -->
  <div class="navbar-zone-right d-flex align-items-center ml-auto">
    <app-stats-info *ngIf="!(hasRightPortal$ | async)" [isCenter]="false"></app-stats-info>

    <!-- Custom Right Portal Template (Module Header Action Buttons) -->
    <ng-container *ngTemplateOutlet="rightPortal$ | async"></ng-container>
  </div>
</div>
